import { Directive, HostListener, inject } from '@angular/core';
import { DialogFocusService } from '../services/a11y/dialog-focus.service';

@Directive({
  selector: '[appDialogTrigger]',
  standalone: true,
})
export class DialogTriggerDirective {
  private dialogFocus = inject(DialogFocusService);


  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  onActivate(event: Event) {
    this.dialogFocus.captureTrigger(event.currentTarget as HTMLElement);
  }
}
